/* eslint-disable */
/* tslint:disable */

import React, {useEffect} from 'react';
import { ConfigProvider, Layout, BackTop, Button, Result, message } from 'antd';
import { observer } from 'mobx-react';
import MainRouter from './routers/main-router';
import { useLocation } from 'react-router-dom';
// order important so we can override antd

import Header from '../components/header/expertHeader';
import '@formily/antd/dist/antd.css';
/*import 'antd/dist/antd.css'*/
import '../App.scss';
import './expert.scss';
import {getEnv} from "../helpers/mobx-easy-wrapper";

const { Content } = Layout;
/* 不需要header和footer的页面 */
const exclusionNavArray = ['/data', '/expert/login'];
const exclusionHeaderArray = ['/expert/login'];
const bgMap = {
  '/data': 'bg__data',
};



const bgColor = window.location.href.indexOf('/expert/login') > 0 ? 'unset' : '#F6F8FE';

function App(props: any) {
    const { apiFactory } = getEnv();
    const loginFlag = apiFactory.authService.isAuthenticated();
    if(window.location.href.indexOf('/expert/login') === -1 && loginFlag === false) {
        message.warn("用户未登录,即将跳转登录")
        setTimeout(()=>{
            window.location.href = "/expert/login";
        },800)
    }
  return (
    <ConfigProvider>
      <div
          style={{height: '100vh'}}
        className={`${
          exclusionNavArray.indexOf(window.location.pathname) < 0
            ? 'has__header'
            : 'login__page'
        }`}
      >
          <>
            <Layout className="">
              {/*     {exclusionNavArray.indexOf(window.location.pathname) < 0 && (  )}*/}
              {exclusionHeaderArray.indexOf(window.location.pathname) < 0 && (
                <>
                  <Header />
                </>
              )}

              <Content className={`${window.location.pathname === '/' ? 'no-padding' : ''} site-layout App`} style={{height:'calc(100vh - 100px)', background: bgColor}}>
                <MainRouter />
                <BackTop />
              </Content>
            </Layout>

          </>

      </div>
    </ConfigProvider>
  );
}

export default observer(App);
